//  埋点上报
import axios from 'axios'
import {
  startPage,
  endPage,
  logClickEvent,
  logViewEvent,
  getDeviceId,
  getUid
} from '@/assets/js/android'

const host = window.location.host
const ENV = process.env.NODE_ENV
// let baseURL = ''
// if(process.env.NODE_ENV === 'development') {
//   baseURL = '/bigApi'
// } else if(process.env.NODE_ENV === 'production') {
//   baseURL = 'https://wolf-api.allcreditcom.com'
// } else {
//   baseURL = 'https://loanstation-bigdata.dexintec.cn'
// }

const request = axios.create({
  baseURL: ENV === 'development' ? '/bigApi' : `https://${host}`
})

request.interceptors.request.use(function (config) {
  config.headers = {
    ...(config.headers || {}),
    'X-BizCode': localStorage.getItem('channel')
  }
  return config
})

function reportApi(eventName, pageName, eventType, customData) {
  const bvn = localStorage.getItem('bvn')
  const channel = localStorage.getItem('channel')
  if (!bvn || !channel) {
    return
  }
  switch (eventType) {
    case 'enter':
      startPage(pageName)
      break
    case 'leave':
      endPage(pageName)
      break
    case 'click':
      logClickEvent(pageName, eventName)
      break
    default:
      logViewEvent(pageName, eventName)
      break
  }
  if (!customData) customData = {}
  const data = [
    {
      channel: channel,
      uid: localStorage.getItem('uid') || getUid() || '',     
      event_name: eventName,
      event_page: pageName,
      event_data: {
        entry_time: eventType === 'enter' ? Date.now() : '',
        leave_time: eventType === 'leave' ? Date.now() : '',
        event_time: Date.now(),
        bvn: bvn,
        device_id: getDeviceId() || '',
        ...customData
      }
    }
  ]
  request.post('/dc/buriedPointBatch', data, {
    headers: {
      'X-DX-Country': 'NG'
    }
  })
}

export default reportApi
